const downloads = [
  {
    name: "Do You - .wav",
    url: "/downloads/005DoYou.wav",
  },
];

export { downloads };

/*
Each download should be listed as follows in above array
{
  name: "Name of download",
  url: "downloads/name_of_file.extension",
}
*/
